<template lang="pug">
.shippingAddress.pt-3.flex.gap-3
  img(src="@/assets/img/location-icon.svg" alt="" class="h-min")
  div.flex.flex-col
    h3.text-lg.font-medium(class="lg1024:text-xl") {{ $t('shipping_address_double_check') }}
    p {{ getAddress() }}
</template>

<script>
import { createAddress } from '@/global/createAddress'

export default {
  name: 'ShippingAddress',
  props: {
    profile: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getAddress() {
      return createAddress(
        this.profile,
        this.$store.state.country,
        this.$t,
        true
      )
    },
  },
}
</script>
